import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import { isValid } from '../../../../utils';

class RecipeIngredient extends Component {
  constructor(props) {
    super(props);
}

  render() {
  	const { data, isChecked, index, toggleCheck } = this.props;
    if (!isValid(data)) { return null; }
  	return (
      <div className="ingredient-wrapper">
      	 <div className="ingredient" itemprop="recipeIngredient" dangerouslySetInnerHTML={ { __html: data } } />
      </div>
    );
  }
}

export default RecipeIngredient;